// @flow

import PaymentOption from './payment-option'

export const PAYMENT_METHOD_FREE = 'free'

export default class PaymentMethod {
  title: string
  options: PaymentOption[]
}

const buildPaymentMethod = function (title: string, options: PaymentOption[] = []): PaymentMethod {
  const paymentMethod = new PaymentMethod()
  paymentMethod.title = title
  paymentMethod.options = options
  return paymentMethod
}

export {
  buildPaymentMethod
}



// WEBPACK FOOTER //
// ./src/types/payment-method.js